export default class Strings {
    public static toTitleCase = (str: string) => str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1));
    public static replaceAll = (str: string, find: string, replace: string): string =>  str.replace(new RegExp(find, 'g'), replace);
}
